/**
 * Même filtrage que `ReservationModal` (moteur réservation) sur la liste `/client/dropdown`.
 * @param {object[]} results
 * @param {string} userRole
 * @param {'physique'|'morale'|null} billingClientKind
 * @param {object|null} currentUser
 */
export function applyMoteurReservationClientListFilter(results, userRole, billingClientKind, currentUser) {
  const r = Array.isArray(results) ? results : [];
  if (!billingClientKind) return [];
  if (userRole === 'admin') {
    if (billingClientKind === 'morale') {
      return r.filter((client) => client.type === 'personne_moral');
    }
    return r.filter(
      (client) =>
        String(client.id_espace_partenaire) === String(currentUser?.user_partner_id) &&
        !client.client_passager,
    );
  }
  return r.filter(
    (client) =>
      String(client.id_espace_partenaire) === String(currentUser?.user_partner_id) ||
      client.client_passager,
  );
}

/** Filtre par type API attendu pour le radio Physique / Morale (aligné moteur). */
export function filterClientsByBillingKind(clients, billingClientKind) {
  if (!billingClientKind || !Array.isArray(clients)) return [];
  const expected = billingClientKind === 'physique' ? 'personne_physique' : 'personne_moral';
  return clients.filter((c) => c.type === expected);
}

/**
 * Pool pour la liste « Sélectionner un client » (même enchaînement que le modal hôtel).
 */
export function buildBillingClientPool(results, userRole, billingClientKind, currentUser) {
  const step1 = applyMoteurReservationClientListFilter(results, userRole, billingClientKind, currentUser);
  return filterClientsByBillingKind(step1, billingClientKind);
}

/**
 * Mappe un client hôtel (dropdown) vers les champs brouillon transfert + champs API (`client_*`).
 * @param {object} client
 */
function resolveBillingPartnerIdFromClient(client) {
  if (client.id_partenaire != null && client.id_partenaire !== '') {
    return Number(client.id_partenaire);
  }
  if (client.type === 'personne_moral') {
    return Number(client.id);
  }
  return null;
}

export function mapHotelClientToTransfertBillingDraft(client) {
  if (!client || !client.id) return null;
  if (client.type === 'personne_physique') {
    const nom = client.nom || '';
    const prenom = client.prenom || '';
    const full = [nom, prenom].filter(Boolean).join(' ').trim();
    return {
      billing_client_id: client.id,
      billing_partner_id: resolveBillingPartnerIdFromClient(client),
      billing_client_kind: 'physique',
      billing_nom: nom,
      billing_prenom: prenom,
      billing_email: client.email || '',
      billing_telephone: client.telephone1 || '',
      billing_adresse_facturation: client.adresse_facturation || '',
      billing_matricule_fiscal: '',
      client_type: 'particulier',
      client_name: full,
      client_email: client.email || '',
      client_phone: client.telephone1 || '',
    };
  }
  return {
    billing_client_id: client.id,
    billing_partner_id: resolveBillingPartnerIdFromClient(client),
    billing_client_kind: 'morale',
    billing_nom: client.nom || '',
    billing_prenom: '',
    billing_email: client.email || '',
    billing_telephone: client.telephone1 || '',
    billing_adresse_facturation: client.adresse_facturation || '',
    billing_matricule_fiscal: client.matricule_fiscal || '',
    client_type: 'entreprise',
    client_name: client.nom || '',
    client_email: client.email || '',
    client_phone: client.telephone1 || '',
  };
}
